import { buildStoredImagePath } from "@reciperoll/core";
import { supabase } from "../lib/supabase";
import { resizeImageFile } from "./resizeImage";

// Upload a user-picked image directly to the recipe-images bucket under their own
// folder (`${userId}/${recipeId}.jpg`, matching the RN convention and Storage
// RLS). This is the user's own local File, uploaded from the browser — no
// cross-origin fetch, so no CORS issue. The bucket is private, so we store the
// object PATH (version-stamped with ?t=) on the recipe's `image` field and sign it
// on display, rather than a public URL.
export async function uploadRecipeImage(
  userId: string,
  recipeId: string,
  file: File,
): Promise<string> {
  const path = `${userId}/${recipeId}.jpg`;
  const body = await resizeImageFile(file);
  const { error } = await supabase.storage
    .from("recipe-images")
    .upload(path, body, {
      contentType: "image/jpeg",
      cacheControl: "31536000", // 1-year immutable; ?t= version-stamps the stored path
      upsert: true,
    });
  if (error) throw error;

  return buildStoredImagePath("recipe-images", userId, recipeId);
}
